import { renderMenuData } from './components/post.js';
import { showNoti } from './helpers.js';

export async function getMenuDatas() {
  const currentUrl = window.location.href;
  const data = await fetch('/wp-json/course-api/v1/menu-data/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
    },
    body: JSON.stringify({
      url: currentUrl,
    }),
  });
  const res = await data.json();
  if (res.status === 'SUCCESS') {
    const HTML = renderMenuData(res.data);
    return HTML;
  }
  if (res.status === 'ERROR') {
    showNoti(res.message);
  }
}
export async function checkCustomerData() {
  const token = localStorage.getItem('token');

  if (!token) {
    console.warn('Token không tồn tại trong localStorage.');
    return;
  }

  try {
    const data = await fetch('https://api.kiem.vn/partner/nmc/detail-for-course', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const res = await data.json();
    console.log(res);

    if (res.status === 'SUCCESS') {
      localStorage.setItem('customerData', JSON.stringify(res.data));
    } else if (res.status === 'ERROR') {
      showNoti(res.message || 'Đã xảy ra lỗi!');
    }
  } catch (err) {
    console.error('Lỗi khi gọi API:', err);
    showNoti('Không thể kết nối đến server!');
  }
}
